import DTO from './DTO';

class HostStatusDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'zbx_hostid',
        type: String,
        validators: [],
        labelKey: 'zbx_hostid',
      },
      {
        name: 'host',
        type: String,
        validators: [],
        labelKey: 'host',
      },
      {
        name: 'status',
        type: Number,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'zbx_location_lat',
        type: String,
        validators: [],
        labelKey: 'parking.meter.zbx_location_lat',
      },
      {
        name: 'zbx_location_lon',
        type: String,
        validators: [],
        labelKey: 'parking.meter.zbx_location_lon',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      id: this.id,
      host: this.host,
    };
  }
}

export default HostStatusDTO;
